import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Typography} from "@mui/material";
import { LoadingPanel } from "../utils/loading_spinner";
import { formatCurrency, formatPercent } from "../utils/formatters";

export const ProfitLeaksTable = ({data, loading=false, selectedLeak, pagination, onPageChange, onPageSizeChange}) => {
    const headerStyle = {
        fontWeight: 'bold',
        backgroundColor: '#f5f5f5',
        borderBottom: '2px solid #ddd'
    }; 
    if (!selectedLeak) {
        return (
            <Paper sx={{p: 2, mt: 2}}>
                <Typography variant="h6" gutterBottom>
                    Profit Leaks Selected:
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Select a profit leak to view details
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper sx={{p: 2, mt: 2}}>
            <Typography variant="h6" gutterBottom>
                Profit Leaks Selected: {selectedLeak.description}
            </Typography>
            {loading ? 
                <LoadingPanel loading={loading} message="Loading profit leaks details..." /> : 
                <TableContainer sx={{ mt: 2 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={headerStyle}>SKU</TableCell>
                                <TableCell sx={headerStyle}>Product Name</TableCell>
                                <TableCell sx={headerStyle}>Customer Account</TableCell>
                                <TableCell sx={headerStyle}>Sales Rep</TableCell>
                                <TableCell sx={headerStyle} align="right">PY PM$</TableCell>
                                <TableCell sx={headerStyle} align="right">CY PM $</TableCell>
                                <TableCell sx={headerStyle} align="right">PM%</TableCell>
                                <TableCell sx={headerStyle} align="right">Impact</TableCell>
                                <TableCell sx={headerStyle} align="right">YoY%</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(!data || data.length === 0) ? (
                                <TableRow>
                                    <TableCell colSpan={9} align="center">
                                        <Typography variant="body2" color="textSecondary">
                                            No detail data available
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                data.map((row, idx) => (
                                    <TableRow key={idx} hover>
                                        <TableCell> {row.product_sku} </TableCell>
                                        <TableCell> {row.product_name} </TableCell>
                                        <TableCell> {row.customer_account} </TableCell>
                                        <TableCell> {row.sales_person} </TableCell>
                                        <TableCell align="right"> { formatCurrency(row.prior_value) } </TableCell>
                                        <TableCell align="right"> { formatCurrency(row.current_value) } </TableCell>
                                        <TableCell align="right"> { formatPercent(row.pm) } </TableCell>
                                        <TableCell align="right"> { formatCurrency(row.impact)} </TableCell>
                                        <TableCell align="right"> { formatPercent(row.yoy) } </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {data && data.length > 0 && pagination && (
                <TablePagination
                    component="div"
                    count={pagination.total || 0}
                    page={pagination.page || 0}
                    onPageChange={(event, newPage) => onPageChange(newPage)}
                    rowsPerPage={pagination.limit || 25}
                    onRowsPerPageChange={(event) => onPageSizeChange(parseInt(event.target.value, 10))}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                />
            )}
        </Paper>
    );
};
